import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findConsumables} from 'Consumables/service/ConsumableService';

export default function SelectConsumable(props) {
  const {value, id, placeholder, name, onChange, label, ...restProps} = props;

  return (
    <SelectEntity
      getEntities={findConsumables}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      {...restProps}
    />
  );
}

SelectConsumable.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    productCode: PropTypes.string,
    supplier: PropTypes.string,
  }),

  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectConsumable.defaultProps = {
  value: null,
  id: null,
  name: null,
  label: 'Consumable',
  placeholder: '',
};
